/**
 * Unit label utilities for displaying units in labels/headers
 * Units are shown in labels, not next to numbers
 * Numbers are displayed as pure numbers, right-aligned
 */

import type { UnitSystem } from './unitConversions';

/**
 * Get unit label for calories
 * Always returns 'kcal' regardless of unit system
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function getCalorieUnitLabel(_unitSystem: UnitSystem): string {
  return 'kcal';
}

/**
 * Get unit label for macros (protein, carbs, fat, fibre, creatine)
 */
export function getMacroUnitLabel(unitSystem: UnitSystem): string {
  return unitSystem === 'imperial' ? 'oz' : 'g';
}

/**
 * Get unit label for hydration
 * BUG FIX #35: Use ml for metric to match how users log entries (e.g., "water 500ml")
 * Metric: ml, Imperial: fl oz
 */
export function getHydrationUnitLabel(unitSystem: UnitSystem): string {
  return unitSystem === 'imperial' ? 'fl oz' : 'ml';
}

/**
 * Get unit label for body weight
 * Metric: kg, Imperial: lb
 */
export function getBodyWeightUnitLabel(unitSystem: UnitSystem): string {
  return unitSystem === 'imperial' ? 'lb' : 'kg';
}

/**
 * Get unit label for food weight
 * Metric: g, Imperial: oz
 */
export function getFoodWeightUnitLabel(unitSystem: UnitSystem, isLiquid: boolean): string {
  if (unitSystem === 'imperial') {
    return isLiquid ? 'fl oz' : 'oz';
  }
  return isLiquid ? 'ml' : 'g';
}

/**
 * Format label with unit
 * Example: "Protein (g)" or "Calories (kcal)"
 */
export function formatLabelWithUnit(label: string, unit: string): string {
  return `${label} (${unit})`;
}

